import React, { useEffect, useState } from 'react'
import {
  MapPropsType,
  CollectionMarkerItemType,
  UniteMarkerModuleItem,
} from './types'
import moment from 'moment'
import { useHistory, useParams } from 'react-router-dom'
import * as moduleActions from '../../containers/ModulePage/actions'
import { useDispatch } from 'react-redux'
import Cookies from 'js-cookie'

// Components
import Marker from '../Marker'

// Style
import './styles.scss'

// Icons
import IconHere from './images/iconHere'

export default ({ image, style, markers, modules, themes }: MapPropsType) => {
  if (!image) return <></>

  const [collectionMarkers, setCollectionMarkers] = useState<
    CollectionMarkerItemType[]
  >([])

  const { id } = useParams<{ id: string }>()

  const prefix = process.env.REACT_APP_URI_PREFIX

  const isAuthed = !!Cookies.get('token')
  const history = useHistory()

  const dispatch = useDispatch()

  const durationAsString = (start: string, end: string): string => {
    const duration = moment.duration(moment(end).diff(moment(start)))

    const timeFormat = (value: number): string => {
      if (value) {
        if (value > 9) return `${value}`
        if (value < 10) return `0${value}`
      }
      return '00'
    }

    const hours = timeFormat(duration.hours())
    const minutes = timeFormat(duration.minutes())
    const seconds = timeFormat(duration.seconds())

    return [hours, minutes, seconds].join(':')
  }

  const timeStartLeft = (start: string): string => {
    const duration = moment.duration(moment(start).diff(moment()))

    const timeFormat = (value: number): string => {
      if (value) {
        if (value > 9) return `${value}`
        if (value < 10) return `0${value}`
      }
      return '00'
    }

    const days = duration.days()
    const hours = timeFormat(duration.hours())
    const minutes = timeFormat(duration.minutes())
    const seconds = timeFormat(duration.seconds())

    return days > 0 ? `${days}дн` : [hours, minutes, seconds].join(':')
  }

  useEffect(() => {
    const flagTypes = ['start', 'finish']

    const uniteMarkerModules: UniteMarkerModuleItem[] = []

    markers.forEach(marker => {
      if (flagTypes.includes(marker.type)) {
        uniteMarkerModules.push(marker)
      } else {
        modules.forEach(module => {
          const markerModuleLesson = module.module_lessons.find(
            moduleLesson =>
              moduleLesson.module_lesson_id === marker.module_lesson_id
          )
          if (markerModuleLesson) {
            uniteMarkerModules.push({
              ...marker,
              moduleLesson: markerModuleLesson,
            })
          }
        })
      }
    })

    const continueMarkers: string[] = []

    uniteMarkerModules
      .filter(marker => !flagTypes.includes(marker.type))
      .forEach(marker => {
        if (
          marker.moduleLesson?.is_joined &&
          !marker.moduleLesson?.is_finished
        ) {
          continueMarkers.push(marker.marker_id)
        }
      })

    if (!continueMarkers.length) {
      uniteMarkerModules
        .filter(marker => marker.moduleLesson)
        .sort((a, b) => {
          if (a.moduleLesson && b.moduleLesson) {
            return a.moduleLesson.index_number - b.moduleLesson.index_number
          } else {
            return 0
          }
        })
        .forEach(marker => {
          if (marker.moduleLesson?.is_finished) {
            continueMarkers.push(marker.marker_id)
          }
        })
    }

    const modulesMarkers: CollectionMarkerItemType[] = uniteMarkerModules.map(
      marker => {
        const moduleLesson = marker.moduleLesson
        const moduleItem = modules.find(
          module => module.module_id === moduleLesson?.module_id
        )
        const lessonItem = moduleLesson?.lesson

        const color = themes.find(
          theme => theme.theme_id === lessonItem?.theme_id
        )?.color

        let timeEnded
        if (
          lessonItem?.user_lesson?.created_at &&
          lessonItem?.user_lesson?.finished_at
        ) {
          timeEnded = durationAsString(
            lessonItem?.user_lesson?.created_at,
            lessonItem?.user_lesson?.finished_at
          )
        }

        let timeStart
        let isBlocked = false
        let isFinished = false

        if (!moduleItem?.is_available_on_time) {
          isBlocked = true
          timeStart = moduleItem?.available_at
            ? timeStartLeft(moduleItem?.available_at)
            : '-'
        }

        if (!moduleLesson?.is_available_on_time) {
          isBlocked = true
          timeStart = moduleLesson?.available_at
            ? timeStartLeft(moduleLesson?.available_at)
            : '-'
        }

        if (moduleItem?.is_blocked || moduleLesson?.is_blocked) {
          isBlocked = true
        }

        if (!!moduleLesson?.is_finished) {
          isFinished = true
        }

        return {
          ...marker,
          moduleId: moduleItem?.module_id,
          lessonId: lessonItem?.lesson_id,
          color: isBlocked && !isFinished ? '#A3A3A3' : color,
          moduleTitle: moduleItem?.title || '',
          lessonTitle: lessonItem?.title || '',
          isAvailable:
            !!moduleLesson?.is_available_on_time &&
            !!moduleItem?.is_available_on_time,
          isBlocked: !!moduleLesson?.is_blocked || !!moduleItem?.is_blocked,
          isJoined: !!moduleLesson?.is_joined,
          isFinished,
          timeEnded,
          timeStart,
          isHere: marker.marker_id === continueMarkers.slice(-1)[0],
          indexNumber: moduleLesson?.index_number,
        }
      }
    )
    setCollectionMarkers([...modulesMarkers])
  }, [markers])

  const handleJoinLesson = (
    moduleId: string | undefined | null,
    lessonId: string | undefined | null
  ) => {
    if (isAuthed) {
      if (lessonId && moduleId) {
        const moduleIsJoined = modules.find(
          module => module.module_id === moduleId
        )?.is_joined
        if (moduleIsJoined) {
          dispatch(moduleActions.joinLesson(id, moduleId, lessonId))
        } else {
          dispatch(moduleActions.joinModuleLesson(id, moduleId, lessonId))
        }
      }
    } else {
      const location = document.location.pathname.replace(prefix, '')
      history.push(`/signin?redirect_uri=${location}`)
    }
  }

  return (
    <div className={'map'} style={style}>
      <div className={'map__background'} />
      <div className={'map__outer'}>
        <img src={image} />
        {collectionMarkers.map(marker => (
          <Marker
            key={marker.marker_id}
            type={marker.type}
            color={marker?.color}
            y={marker.position_y}
            x={marker.position_x}
            moduleTitle={marker?.moduleTitle || ''}
            lessonTitle={marker?.lessonTitle || ''}
            moduleId={marker?.moduleId}
            lessonId={marker?.lessonId}
            timeStart={marker?.timeStart}
            timeEnded={marker?.timeEnded}
            onJoinLesson={handleJoinLesson}
            courseId={id}
            isAvailable={marker.isAvailable}
            isBlocked={marker.isBlocked}
            isJoined={marker.isJoined}
            isFinished={marker.isFinished}
            isHere={marker.isHere}
            indexNumber={marker.indexNumber}
          />
        ))}
      </div>
      <div className={'map__legend'}>
        <div className={'map__legend-item'}>
          <IconHere />
          <span>Ты здесь</span>
        </div>
        {themes.map(theme => (
          <div className={'map__legend-item top'} key={theme.theme_id}>
            <div className={'circle'} style={{ background: theme.color }} />
            <span>
              Тема урока:
              <br />
              {theme.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
